<script>
import LocationAPI from './../../api/location.js'

export default {
  name: 'LocationSelection',
  data () {
    return {
    	location: null,
    	location_query: '',
    	timeout: null,
    	loading: true,
   		location_list: []
    }
  },
  methods: {
  	async loadLocations () {
  		this.loading = true
  		clearTimeout(this.timeout)
  		this.timeout = setTimeout(() => {
  			 try {
		        var location_request = LocationAPI.getLocations()
	  			location_request.then((response) => {
	  				this.location_list = response
            this.loading = false
	  			})
	        } catch (error) {
	          this.loading = false
	        }
  		}, 1000)
  	},
    selectLocation (location) {
      this.location_query = location.citymunDesc
      this.$emit('onSelect', location)
    }

  },
  mounted () {
  	this.loadLocations()
  }
}
</script>

<template>
<div class="location-selection">
	<input type="text" v-model="location_query" placeholder="Enter your location" @input="loadLocations">
	<ul class="location-list" v-if="!loading">
		<li class="location-group" v-for="location_group in location_list">
			<p>{{ location_group.city_group_name }}</p>
			<ul class="location-items">
				<li v-for="city in location_group.cities" @click="selectLocation(city)">{{ city.citymunDesc }}</li>
			</ul>
		</li>
	</ul>
	<div class="location-preloader" v-if="loading">
		<div class="spinner">
	        <div class="dot1"></div>
	        <div class="dot2"></div>
	    </div>
	</div>
</div>
</template>

<style>
.location-selection input {
    margin: 0;
    margin-bottom: 10px;
}
ul.location-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
}
ul.location-list .location-group p {
    font-size: 0.75em;
    font-weight: bold;
    margin: 0;
}
ul.location-list .location-group .location-items {
    list-style-type: none;
    padding: 0;
    margin: 0;
}
ul.location-list .location-group .location-items li {
    margin: 0px;
    padding: 5px 10px;
    cursor: pointer;
}
ul.location-list .location-group .location-items li:hover {
    background: #f1f1f1;
    transition: 0.2s all ease;
}
ul.location-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
    max-height: 200px;
    overflow-y: scroll;
}
.location-preloader .spinner {
    margin: 0;
}
.location-preloader {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/LocationSelection.vue